import Swal from 'sweetalert2'

function dataMethod () {
  let tokenMeta = document.querySelector('meta[name=\'csrf-token\']')
  if (!tokenMeta) {
    console.error('token meta [csrf-token] is not set')
    return
  }
  let dataMethods = document.querySelectorAll('[data-method]')
  if (!dataMethods) return
  dataMethods.forEach((dataMethod) => {
    let form = document.createElement('form')
    form.setAttribute('method', 'post')
    form.setAttribute('action', dataMethod.getAttribute('href'))
    let methodInput = document.createElement('input')
    methodInput.setAttribute('name', '_method')
    methodInput.setAttribute('type', 'hidden')
    methodInput.setAttribute('value', dataMethod.getAttribute('data-method'))
    form.appendChild(methodInput)

    let tokenInput = document.createElement('input')
    tokenInput.setAttribute('name', '_token')
    tokenInput.setAttribute('type', 'hidden')
    tokenInput.setAttribute('value', tokenMeta.content)
    form.appendChild(tokenInput)

    dataMethod.appendChild(form)
    dataMethod.setAttribute('href', '#')
    dataMethod.addEventListener('click', (e) => {
      e.preventDefault()
      if (dataMethod.hasAttribute('data-confirm')) {
        Swal({
          type: dataMethod.hasAttribute('data-type') ? dataMethod.getAttribute('data-type') : 'warning',
          title: 'Attention',
          text: dataMethod.getAttribute('data-confirm'),
          showConfirmButton: true,
          confirmButtonText: 'Oui, procéder',
          showCancelButton: true,
          cancelButtonText: 'Non, annuler'
        }).then((result) => {
          if (result.value) {
            form.submit()
          }
        })
      } else {
        form.submit()
      }
    })
  })
}

export default dataMethod



// WEBPACK FOOTER //
// ./resources/assets/js/data-method.js